(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("vsv_api", [], factory);
	else if(typeof exports === 'object')
		exports["vsv_api"] = factory();
	else
		root["vsv_api"] = factory();
})(window, function() {
return 